var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_cof.js
// module id = 160
// module chunks = 168707334958949